import Cookies from 'js-cookie'

import { getSharedCookieDomain } from './shared-cookie-domain'

export const TEMP_CREDENTIALS_COOKIE_NAME = 'TempCredentials'

function getSignaterDomain(): string | undefined {
  return getSharedCookieDomain(window.location.hostname)
}

export function getTempCredentialsCookie(): string | undefined {
  return Cookies.get(TEMP_CREDENTIALS_COOKIE_NAME)
}

export function removeTempCredentialsCookie(): void {
  const domain = getSignaterDomain()
  if (!domain) return
  Cookies.remove(TEMP_CREDENTIALS_COOKIE_NAME, { domain, path: '/' })
}
